import { AxiosInstance } from "axios";
import Endpoint from "@/utils/endpoint";
import ErrorService from "./erroService";
import LesteManagerItem from "@/types/app/lesteManagerItem";

export default class LesteManagerService {
  constructor(
    private api: AxiosInstance,
    private endpoint: Endpoint = new Endpoint()
  ) {}

  async getSelectLesteManagerItems(customerId:string): Promise<LesteManagerItem[]> {
    return await this.api
      .get(`${this.endpoint.lesteUser}/items?customerId=${customerId}`)
      .then((res) => {
        return res.data as LesteManagerItem[];
      })
      .catch((res) => {
        console.log('getSelectLesteManagerItems', res);
        ErrorService.onError(res);
        return [];
      });
  }

  async saveItems(customerId:string, isClientUser:boolean, clients:LesteManagerItem[]){
    return await this.api
      .post(`${this.endpoint.lesteUser}/save-items/${customerId}`, 
       {
        isClientUser,
        ItemIds: clients.map(x => x.id)
      })
      .then((res) => {
        return res.data as boolean;
      })
      .catch((res) => {
        console.log('getSelectLesteManagerItems', res);
        ErrorService.onError(res);
        return [];
      });
  }

  async deleteItems(customerId:string, isClientUser:boolean, itemId:string){
    return await this.api
      .delete(`${this.endpoint.lesteUser}/delete-items/${customerId}/${isClientUser}/${itemId}`)
      .then((res) => {
        return res.data as boolean;
      })
      .catch((res) => {
        console.log('deleteItems', res);
        ErrorService.onError(res);
        return [];
      });
  }
}
